module.exports = __webpack_public_path__ + "static/img/Aaclogomax2.74e3ad9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Aaclogomax2.png
// module id = 1pTc
// module chunks = 1